import { motColumns, trudMotivTestData } from "../../../data/TrudMotivTestData";

export const trudMotivTestAnalysis = (answers) => {
  const result = {
    in: 0, // Инструментальный
    pr: 0, // Профессиональный
    pa: 0, // Патриотический
    ow: 0, // Хозяйский
    lu: 0, // Избегающий тип (офисный)
  };

  Object.entries(answers).forEach(([questionId, selectedOptionIds]) => {
    const question = trudMotivTestData
      .find((q) => q.id === "questions")
      ?.questions.find((q) => q.id === Number(questionId));

    if (question) {
      selectedOptionIds.forEach((optionId) => {
        const option = question.options.find((opt) => opt.id === optionId);
        if (option && option.type) {
          const types = Array.isArray(option.type) ? option.type : [option.type];
          types.forEach((type) => {
            if (result[type] !== undefined) {
              result[type] += 1;
            }
          });
        }
      });
    }
  });

  const readable = Object.entries(result)
    .map(([key, value], index) => `${index+1}. ${motColumns[index]}: ${value}`)
    .join("\n");

  return {
    result,  
    readable, 
  };
};
